import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetchPurchaseInvoiceById({ commit, dispatch }, id) {
        return new Promise((resolve, reject) => {
          ajax
            .get("Shipping/api/PurchaseInvoicesQuery/remaining-of-count/" + id)
            .then((r) => {
              // commit("setDetails", r.data);
              resolve(r.data);
            })
            .catch((e) => reject(e));
        });
      },
    fetchSendCargoById({ commit, dispatch }, id) {
        return new Promise((resolve, reject) => {
          ajax
            .get("Shipping/api/SendShipmentsQuery/" + id)
            .then((r) => {
              // commit("setDetails", r.data);
              resolve(r.data);
            })
            .catch((e) => reject(e));
        });
      },
    fetchShipmentById({ commit, dispatch }, id) {
        return new Promise((resolve, reject) => {
          ajax
            .get("Shipping/api/ReceiveShipmentsQuery/count-of-remaining/" + id)
            .then((r) => {
              // commit("setDetails", r.data);
              resolve(r.data);
            })
            .catch((e) => reject(e));
        });
      },
      
      saveShipment({ commit, dispatch }, model) {
        return new Promise((resolve, reject) => {
          ajax
            .post("Shipping/api/ReceiveShipments", model).then((r) => {
              resolve(r.data);
            }).catch((e) => console.log(e));
        });
      },     
      saveRecievePackage({ commit, dispatch }, model) {
        return new Promise((resolve, reject) => {
          ajax
            .post("Shipping/api/Packages/receive-package", model).then((r) => {
              resolve(r.data);
            }).catch((e) => console.log(e));
        });
      },     
      saveSerial({ commit, dispatch }, model) {
        return new Promise((resolve, reject) => {
          ajax
            .put("Shipping/api/Shipments/update-serials-of-items", model).then((r) => {
              resolve(r.data);
            }).catch((e) => console.log(e));
        });
      },     
      gotoClose({ commit, dispatch }, model) {
        return new Promise((resolve, reject) => {
          ajax
            .put("Shipping/api/Shipments/go-to-close", model).then((r) => {
              resolve(r.data);
            }).catch((e) => console.log(e));
        });
      },     
      saveCurrencyType({ commit, dispatch }, model) {
        return new Promise((resolve, reject) => {
          ajax
            .put("Shipping/api/Shipments/update-currency-info", model).then((r) => {
              resolve(r.data);
            }).catch((e) => console.log(e));
        });
      },     
      saveDeductionAndIncrease({ commit, dispatch }, model) {
        return new Promise((resolve, reject) => {
          ajax
            .put("Shipping/api/Shipments/update-deduction-and-increases", model).then((r) => {
              resolve(r.data);
            }).catch((e) => console.log(e));
        });
      },
      updatePassagePermit({ commit, dispatch }, model) {
        return new Promise((resolve, reject) => {
          ajax
            .put("Shipping/api/Shipments/update-passage-permit", model).then((r) => {
              resolve(r.data);
            }).catch((e) => console.log(e));
        });
      },
     },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
